const initialvalues = {
    DistList: [],
    mandalList: [],
    villageList: [],
    habitationList: [],
    nocservices: [],
    getScrutinyInputDetails: null,
    getScrutinyCollegeDetails: null,
    getScrutinyAccommodation: [],
    getcoursesscrutinylist: [],
    conversionScrutinySavedDetails: null,
    DashboardCounts: [],

};


export default function CommonMastersReducer(details = initialvalues, action) {
    switch (action.type) {
        case "DISTRICTLIST":
            return { ...details, DistList: action.payload };
        case "VILLAGESLIST":
            return { ...details, villageList: action.payload };
        case "MANDALSLIST":
            return { ...details, mandalList: action.payload };
        case "HabitationLIST":
            return { ...details, habitationList: action.payload };

        case "NOC_SERVICES":
            return { ...details, nocservices: action.payload };


        case "GET_SCRUTINY_INPUT_DETAILS":
            return { ...details, getScrutinyInputDetails: action.payload };

        case "GET_SCRUTINY_COLLEGE_DETAILS":
            return { ...details, getScrutinyCollegeDetails: action.payload };

        case "GET_SCRUTINY_ACCOMMODATION":
            return { ...details, getScrutinyAccommodation: action.payload };

        case "GET_COURSES_SCRUTINY_LIST":
            return { ...details, getcoursesscrutinylist: action.payload };

        case "CONVERSION_SCRUTINY_SAVED_DETAILS":
            return { ...details, conversionScrutinySavedDetails: action.payload };
        case "DASHBOARD_COUNTS":
            return { ...details, DashboardCounts: action.payload };



        default:
            return details;
    }
}